import React from 'react'
import { useFormContext } from "react-hook-form";
import { inputData, ExternalPressureResults, Summary } from "./inputFields/ellipticalHeadInputFormat"

import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import InputAdornment from '@mui/material/InputAdornment';
import '@fontsource/roboto/300.css';
import Stack from '@mui/material/Stack';
import CustomTextField from "../../../../../components/widgets/CustomTextField"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const GridStyle = {
    "&.MuiGrid-item": { p: "3px 0px 0px 5px" }
}

const subHeadingStyle = {
    color: "#4e5fa2",
    fontWeight: "bold",
    mb: "5px"
}

const typographySize = {
    fontSize: "0.8rem"
}

const formulaStyle = {
    // color: "#4e5fa2",
    // mb: "5px"
    // fontFamily: "Blanco",
    // fontStyle: "italic"
}

// fontsizeL 0/8rem

const EllipticalHeadTab = (props) => {
    const { calculationResult } = props
    const { getValues } = useFormContext();

    const getLabel = () => {
        let Dia = getValues("diameterBasis")
        if (Dia === "ID")
            return "Inside Diameter"
        else if (Dia === "OD")
            return "Outside Diameter"
        else
            return "Diameter"
    }

    return (
        <div style={{ width: '100%' }} width='100%'>
            {/* <Typography variant="h6" color="primary" marginLeft = "10rem">Elliptical Head</Typography> */}
            {/* <br /> */}
            <Typography sx={{ ...subHeadingStyle }} >Input Data</Typography>
            {/* <br /> */}
            {/* <br /> */}

            {/* Input Data */}
            {/* <Grid container spacing={2} columns={{ xs: 10, sm: 8, md: 8, lg: 11, xl: 12 }}> */}
            <Grid container sx={{ alignItems: "center" }} columns={{ xs: 11, lg: 11, xl: 12 }}>
            <Table sx={{ width: 580 }} size="small" aria-label="simple table" >
                    <TableBody>
                        {inputData.map(input => (
                            <TableRow
                                key={input.label}
                                sx={{ border: "none" }}
                            >
                                <TableCell component="th" scope="input" sx={{ padding: "5px", width: "281px", border: "none" }}>
                                    {input.label === "Inside/Outside Diameter" ? getLabel() : input.label}
                                </TableCell>
                                <TableCell align="right" sx={{ padding: "5px", width: "124.5px", border: "none" }}>{input.variable}</TableCell>
                                <TableCell sx={{ padding: "5px", border: "none" }}>
                                    <CustomTextField
                                        hiddenLabel={true}
                                        id={input.txtFieldName}
                                        name={input.txtFieldName}
                                        type={input.type}
                                        required={true}
                                        disabled={input?.disabled || false}
                                        pairField={input.pairField || null}
                                        inputProps={{
                                            endAdornment: <InputAdornment position="end">{input.inputProps}</InputAdornment>,

                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>

            {/* Thickness */}
            <br />
            <Typography sx={{ ...subHeadingStyle }}>Thickness due to Internal Pressure (Tr)</Typography>
            <Typography {...typographySize} sx={{ mb: "3px", ...formulaStyle }}>{calculationResult?.Label461 || "Tr = ( P* (D+2*CA) * K) / ( 2 * S * E - 0.2 * P) Appendix 1-4 (c)"}</Typography>
            <Typography {...typographySize} sx={{ mb: "3px", ml: "2.1ch", ...formulaStyle }}>{calculationResult?.Label9 || ""}</Typography>
            <Stack direction="row" spacing={0.2} sx={{ alignItems: "end" }}>
                <Typography sx={{  width: "fit-content", ml: "2.1ch" }}>
                    =
                </Typography>
                <CustomTextField
                    hiddenLabel={true}
                    id="txt_TR_EHC"
                    name="txt_TR_EHC"
                    type="number"
                    // pairField={input.pairField || null}
                    inputProps={{
                        style: { backgroundColor: "e5e8f2", width: "15ch", fontSize: "0.875rem", height: "24px" },
                        endAdornment: <InputAdornment position="end">mm</InputAdornment>
                    }}
                />
            </Stack>


            {/* MAWP */}
            <br />
            <Typography sx={{ ...subHeadingStyle }}>Max. All Working Pressure at Thickness (MAWP)</Typography>
            <Typography {...typographySize} sx={{ mb: "3px", ...formulaStyle }}>{calculationResult?.Label465 || "MAWP = (2*S*E*(T-CA-CAE)) / (K*(D/2+CA)+0.2*(T-CA-CAE)) per Appendix 1-4 (c)"}</Typography>
            <Typography {...typographySize} sx={{ mb: "3px", ml: "6ch", ...formulaStyle }}>{calculationResult?.Label30 || ""}</Typography>
            <Stack direction="row" spacing={0.2} sx={{ alignItems: "end" }}>
                <Typography sx={{  width: "fit-content", ml: "6ch" }}>
                    =
                </Typography>
                <CustomTextField
                    hiddenLabel={true}
                    id="txt_MAWP_EHC"
                    name="txt_MAWP_EHC"
                    type="number"
                    disabled
                    // pairField={input.pairField || null}
                    inputProps={{
                        style: { backgroundColor: "e5e8f2", width: "20ch", fontSize: "0.875rem", height: "24px" },
                        // endAdornment: <InputAdornment position="end">N/mm^2</InputAdornment>
                    }}
                />
            </Stack>

            {/* MAPNC */}
            <br />
            <Typography sx={{ ...subHeadingStyle }}>Max. All Pressure New and Cold (MAPNC)</Typography>
            <Typography {...typographySize} sx={{ mb: "3px", ...formulaStyle }}>{calculationResult?.Label469 || "MAPNC = ( 2 * SA * E * T ) / (K * D + 0.2 * T ) per Appendix 1-4 (c)"}</Typography>
            <Typography {...typographySize} sx={{ mb: "3px", ml: "6.8ch", ...formulaStyle }}> {calculationResult?.Label34 || ""}</Typography>
            <Stack direction="row" spacing={0.2} sx={{ alignItems: "end" }}>
                <Typography sx={{  width: "fit-content", ml: "6.8ch" }}>
                    =
                </Typography>
                <CustomTextField
                    hiddenLabel={true}
                    id="txt_MAPNC_EHC"
                    name="txt_MAPNC_EHC"
                    type="number"
                    disabled
                    // pairField={input.pairField || null}
                    inputProps={{
                        style: { backgroundColor: "e5e8f2", width: "20ch", fontSize: "0.875rem", height: "24px" },
                        // endAdornment: <InputAdornment position="end">N/mm^2</InputAdornment>
                    }}
                />
            </Stack>

            {/* External Pressure Results */}
            <br />
            <Typography sx={{ ...subHeadingStyle }}>External Pressure Results</Typography>
            <Grid container sx={{ alignItems: "center" }} columns={{ xs: 11, lg: 11, xl: 12 }}>
                <Table sx={{ width: 580 }} size="small" aria-label="simple table" >
                    <TableBody>
                        {ExternalPressureResults.map(input => (
                            <TableRow
                                key={input.label}
                                sx={{ border: "none" }}
                            >
                                <TableCell component="th" scope="input" sx={{ padding: "5px", width: "18rem", border: "none", fontSize: "0.8rem" }}>
                                    {input.label}
                                </TableCell>
                                <TableCell align="right" sx={{ padding: "5px", width: "124.5px", border: "none" }}>{input.variable}</TableCell>
                                <TableCell sx={{ padding: "5px", border: "none" }}>
                                    <CustomTextField
                                        hiddenLabel={true}
                                        id={input.txtFieldName}
                                        name={input.txtFieldName}
                                        type={input.type}
                                        required={input.required}
                                        disabled={input.disabled || false}
                                        pairField={input.pairField || null}
                                        inputProps={{
                                            endAdornment: <InputAdornment position="end">{input.inputProps}</InputAdornment>,
                                            style: {
                                                width: "25ch", fontSize: "0.7rem", height: "18px",
                                            }
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>

            {/* Summary */}
            <br />
            <Typography sx={{ ...subHeadingStyle }}>Summary</Typography>
            <Grid container sx={{ alignItems: "center" }} columns={{ xs: 11, lg: 11, xl: 12 }}>
                <Table sx={{ width: 640 }} size="small" aria-label="simple table" >
                    <TableBody>
                        {Summary.map(input => (
                            <TableRow
                                key={input.label}

                                sx={{ border: "none" }}
                            >
                                <TableCell component="th" scope="input" sx={{ padding: "5px", width: "18rem", border: "none", fontSize: "0.8rem" }}>
                                    {input.label}
                                </TableCell>
                                <TableCell align="right" sx={{ padding: "5px", width: "8rem", border: "none", fontSize: "0.8rem" }}>{input.variable}</TableCell>
                                <TableCell sx={{ padding: "5px", border: "none", fontSize: "0.8rem" }}>
                                    <CustomTextField
                                        hiddenLabel={true}
                                        id={input.txtFieldName}
                                        name={input.txtFieldName}
                                        type={input.type}
                                        required={input.required}
                                        disabled={input.disabled || false}
                                        pairField={input.pairField || null}
                                        inputProps={{
                                            endAdornment: <InputAdornment position="end">{input.inputProps}</InputAdornment>,
                                            style: {
                                                width: "25ch", fontSize: "0.7rem", height: "18px",
                                            }
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </Grid>
        </div>
    )
}

export default EllipticalHeadTab